<template>
    <div class="backBox">
        <div>
            <img src="../../assets/network-card/person-fail.png" style="width: 100%">
            <div style="text-align: center;font-size: 2.7vh;padding-top: 2vh">
                <b>身份认证失败</b>
            </div>
        </div>
        <div class="fixBottom">
            <van-button round color="#286EFF" class="next-btn" @click="closeTip">关闭</van-button>
        </div>
    </div>
</template>

<script>
import { Button } from "vant";
import { closeWindow } from "@/util/jsbridge"

export default {
    name: "VerifyFail",
    components:{
        [Button.name]:Button,
    },
    methods:{
        closeTip(){
            closeWindow();
        }
    }
}
</script>

<style scoped lang="less">
    @import "../../../static/less/common";
</style>
